<template>
  <li class="has-user-block">
    <div class="collapse" :class="{'show': show_user_block}" id="user-block">
      <div class="item user-block">
        <div class="user-block-info">
          <span class="user-block-name">
            {{ user_name }}
            <a href="/profile" :title="$t('userblock.edit')">
              <i class="fa icon-note pl-1"></i>
            </a>
          </span>
          <span class="user-block-role">{{ user_group }}</span>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  computed: {
    user_name() {
      return this.$store.getters.user_name
    },
    user_group() {
      return this.$store.getters.user_group
    },
    show_user_block() {
      return this.$store.getters.show_user_block === 'yes'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Userblock.vue